import { render } from "./LevelOneChartOfAccountsPage.vue?vue&type=template&id=64302f72&scoped=true"
import script from "./LevelOneChartOfAccountsPage.vue?vue&type=script&lang=js"
export * from "./LevelOneChartOfAccountsPage.vue?vue&type=script&lang=js"

import "./LevelOneChartOfAccountsPage.vue?vue&type=style&index=0&id=64302f72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64302f72"]])

export default __exports__